import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Reveal the SPA & fade out the pre-hydration splash once React has mounted.
requestAnimationFrame(() => {
  document.documentElement.classList.add("app-ready");
  const splash = document.getElementById("boot-splash");
  if (splash) setTimeout(() => splash.remove(), 400);
});
